module.exports = __webpack_public_path__ + "static/img/IMG_20170905_191532.5aa81a93.jpg";